export const DESKTOP_MINIMUM_WIDTH = 780;
